export enum CurrencyFlightHourTypeEnum {
  Flight = 1,
  Block = 2
}
